import { isAxiosError } from "axios";

const MALWARE_SCAN_CODES = new Set(["MALWARE_SCAN_PENDING", "MALWARE_SCAN_BLOCKED", "MALWARE_SCAN_REMOVED"]);

export function getMalwareScanMessage(error: unknown): string | null {
  if (!isAxiosError<{ code?: string; message?: string }>(error)) return null;
  const data = error.response?.data;
  if (!data?.code || !MALWARE_SCAN_CODES.has(data.code)) return null;
  return data.message ?? null;
}
